import type { StateParamsDeclaration } from "app/pages/sales-intelligence/types/routing";

import type { SavedSearchRoutingParams } from "../types";

export const savedSearchParams: StateParamsDeclaration<SavedSearchRoutingParams> = {
    savedSearchId: { type: "string", value: null, dynamic: true },
};
